<template>
  <div class="packageContainer">
    <div class="flex-around">
      <div class="flex-center">
        <div class="cartTip"></div>
        7天无理由退换
      </div>
      <div class="flex-center">
        <div class="cartTip"></div>
        当天快速退款
      </div>
      <div class="flex-center">
        <div class="cartTip"></div>
        微信认证
      </div>
    </div>
    <div v-if="packageGoods.length > 0">
      <div class="addressTop">
        <van-cell
          icon="location-o"
          v-if="defaultAddress"
          :title="address.name + '，' + address.tel"
          :label="address.address"
          clickable
          value-class="address-tel"
          class="address"
          size="large"
          is-link
          @click="chooseAddress"
        ></van-cell>
        <van-cell
          v-else
          clickable
          is-link
          @click="chooseAddress"
          class="cAddress"
          >请选择地址</van-cell
        >
      </div>

      <van-cell :title="packageName" class="packageName"></van-cell>

      <div style="margin-bottom: 20vw">
        <div
          class="cart"
          v-for="(item, index) in packageGoods"
          :key="item.skuId"
        >
          <van-card
            :title="item.goodsName"
            :desc="item.specificationNames"
            :num="item.quantity"
            :thumb="item.pictureUrl"
            class="card_shop"
          >
            <div slot="num">
              <van-stepper
                :min="item.minQuantity"
                :max="item.maxQuantity"
                @change="onQuantityChange(item.quantity, index)"
                v-model="item.quantity"
              />
            </div>
          </van-card>
        </div>
      </div>
    </div>
    <van-submit-bar
      class="cart-submit"
      :price="totalPrice"
      button-text="下单"
      @submit="onSubmit"
      :safe-area-inset-bottom="true"
      :loading="loading"
      :disabled="disabled"
    >
    </van-submit-bar>
    <van-overlay :show="isLoading">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import {
  Checkbox,
  CheckboxGroup,
  Card,
  SubmitBar,
  Button,
  Stepper,
  Col,
  Row,
  Grid,
  GridItem,
  Toast,
  Cell,
  Notify,
  Dialog,
  Overlay
} from "vant";
import { mapGetters } from "vuex";
import service from "../../api/package/index";
import serviceAddress from "../../api/checkout/index";
import { wxPay } from "../../util/wxHelper";
import servicePay from "../../api/payment/wxpay/index";
import loading from "../../components/loading/loading";
export default {
  components: {
    [Cell.name]: Cell,
    [Card.name]: Card,
    [Checkbox.name]: Checkbox,
    [SubmitBar.name]: SubmitBar,
    [CheckboxGroup.name]: CheckboxGroup,
    [Button.name]: Button,
    [Stepper.name]: Stepper,
    [Col.name]: Col,
    [Row.name]: Row,
    [Toast.name]: Toast,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Notify.name]: Notify,
    [Dialog.name]: Dialog,
    [Overlay.name]: Overlay,
    loading
  },

  data() {
    return {
      disabled: false,
      isLoading: true, //loading状态
      defaultAddress: false,
      id: 0,
      address: {},
      goods: [],
      isEdit: false,
      loading: false,
      getParamsAddress: {},
      // packageGoods: [],
      packageGoods: [],
      checkedGoods: [], //选中的值
      name: "",
      totalPrice: 0,
      // packageGoodsQuantity: 0,
      totalGoodsQuantity: 0,
      submitData: {
        package: {
          packageId: 0,
          packageItemDic: {}
        }
      },
      responseData: {},
      packageName: "套餐活动"
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    packageGoodsQuantity() {
      return this.packageGoods.reduce(
        (total, item) => total + item.quantity,
        // (this.checkedGoods.indexOf(item.skuId) !== -1 ? item.quantity : 0),
        0
      );
    },

    // "packageItemDic": { "additionalProp1": 0, "additionalProp2": 0, "additionalProp3": 0 }
    packageItemDic() {
      var packageItemDic = {};
      this.packageGoods.map((item) => {
        // if (this.checkedGoods.indexOf(item.skuId) !== -1) {
        //   console.log(packageItemDic, item.skuId, item.quantity, 413);
        packageItemDic[item.skuId] = item.quantity;
        // }
      });
      return packageItemDic;
    },
    isCheckedAll: {
      get() {
        return this.checkedGoods.length == this.packageGoods.length;
      },
      set(val) {
        if (!val) {
          this.checkedGoods = [];
        } else {
          let goodsChecked = [];
          this.packageGoods.map((item) => {
            goodsChecked.push(item.skuId);
          });
          this.checkedGoods = goodsChecked;
        }
      }
    }
  },
  Destroy() {
    localStorage.removeItem("getParamsAddress");
  },

  mounted() {
    this.init(this.$route.query.id);
    if (localStorage.getItem("getParamsAddress")) {
      this.getParamsAddress = JSON.parse(
        localStorage.getItem("getParamsAddress")
      );
    }
    if (this.getParamsAddress.addressId) {
      this.defaultAddress = true;
      this.address = {
        id: this.getParamsAddress.address.id,
        name: this.getParamsAddress.address.name,
        tel: this.getParamsAddress.address.tel,
        address: this.getParamsAddress.address.address
      };
      this.submitData.addressId = this.getParamsAddress.address.id;
    } else {
      this.getAddress();
    }
    // this.$log.debug("userInfo", this.userInfo);
  },
  methods: {
    formatPrice(price) {
      if (price >= 1) {
        return price.toFixed(2);
      } else {
        return price;
      }
    },
    //
    onStatusChange(index) {
      for (var v = 0; v < this.packageGoods.length; v++) {
        if (this.checkedGoods.indexOf(this.packageGoods[v].skuId) >= 0) {
          this.packageGoods[v].checked = true;
        } else {
          this.packageGoods[v].checked = false;
        }
      }
      this.packageGoods.map((v) => {});
    },
    onQuantityChange(value, index) {
      if (value == this.packageGoods[index].minQuantity) {
        Toast("最少购买" + this.packageGoods[index].minQuantity + "件");
        this.packageGoods[index].quantity = value;
        return;
      } else if (value == this.packageGoods[index].maxQuantity) {
        Toast("最多购买" + this.packageGoods[index].maxQuantity + "件");
        this.packageGoods[index].quantity = value;
        return;
      } else {
        this.packageGoods[index].quantity = value;
        return;
      }
    },
    init(id) {
      service
        .getPackages(id)
        .then((response) => {
          setTimeout(() => {
            this.isLoading = false;
          }, 500);
          this.responseData = response.data;
          this.$log.debug("packageGoods", this.address);
          // 最后合计总价钱
          this.totalPrice = response.data.price * 100;
          this.packageGoods = response.data.goodsPackageItems;
          this.submitData.package.packageId = response.data.id;
          this.totalGoodsQuantity = response.data.goodsQuantity;
          this.packageName = response.data.packageName;
        })
        .catch((error) => {
          setTimeout(() => {
            this.isLoading = false;
          }, 500);
          if (error.status == 404) {
            this.showEmpty = true;
          }
        });
    },
    chooseAddress() {
      this.$router.push({
        name: "addresslist",
        query: { name: this.$route.name, id: this.packageId }
      });
    },
    getAddress() {
      serviceAddress.getDefault().then((response) => {
        if (response.statusCode == 200 && response.data !== null) {
          this.defaultAddress = true;
          this.address = {
            name: response.data.name,
            tel: response.data.cellPhone,
            address:
              response.data.province +
              response.data.city +
              response.data.district +
              response.data.details,
            id: response.data.id
          };

          this.addressId = response.data.id;
          this.submitData.addressId = response.data.id;
        }
      });
    },
    onSubmit() {
      if (this.address.id == undefined) {
        Toast("请输入收货地址");
        return false;
      }
      if (!this.userInfo.phoneNumber) {
        Dialog.alert({
          title: "提示",
          message: "只有绑定手机号码才能购买哦"
        }).then(() => {
          this.$router.push("setting");
        });
        return;
      }

      this.isLoading = true;
      //   现在的打包一口价是一个包 可以自由添加多少（在库存够的情况下） 打包一口价 ：3
      this.submitData.orderType = 3;
      this.submitData.package.packageItemDic = this.packageItemDic;
      if (this.packageGoodsQuantity !== this.totalGoodsQuantity) {
        // this.totalPrice = this.packageGoods.retailPrice * 100;
        this.isLoading = false;
        Toast("购买总数量只能是" + this.totalGoodsQuantity + "件");
      } else {
        // this.isLoading = false;
        // this.disabled = true;
        service
          .checkoutPackage(this.submitData)
          .then((res) => {
            setTimeout(() => {
              this.isLoading = false;
            }, 3000);
            var orderId = res.data;
            if (res.statusCode == 200) {
              orderId = res.data.orderId;
              servicePay
                .unifiedOrder(orderId, this.userInfo.openId)
                .then((response) => {
                  if (response.statusCode !== 200) {
                    Toast(response.errors);
                    return;
                  }
                  // this.isLoading = false;
                  wxPay(response.data)
                    .then(() => {
                      this.$router.push({
                        name: "payResult",
                        query: { id: orderId, status: true }
                      });
                    })
                    .catch((err) => {
                      // Notify({ type: "danger", message: err.errMsg });
                      // 后台没有返回内容 所以注释
                      // Toast(err)
                      // this.isLoading = false;
                      this.$router.push({
                        name: "payResult",
                        query: { id: orderId, status: false }
                      });
                    });
                })
                .catch();
            }
          })
          .catch((err) => {
            // Toast(err);
            this.isLoading = false;
          });
      }
    }
  }
};
</script>
<style lang="less" scoped>
@deep: ~">>>";
.packageContainer {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  // background: #f4f4f4;
  // margin-bottom: 15vw;
  .van-overlay {
    z-index: 102;
  }
  .cart {
    padding: 0 2.4vw;
    background: #fff;
    border-bottom: 1px solid #f8f8f8;
  }
  .van-cell__right-icon {
    line-height: 46px;
    height: 46px;
  }

  .flex-around {
    height: 32px;
    color: #929292;
    background-color: #f3f3f3;
    font-size: 12px;
  }
  .cartTip {
    width: 1.2vw;
    height: 1.2vw;
    border-radius: 50%;
    background: #ee0a24;
    margin-right: 4px;
  }

  .van-card__content {
    flex-direction: inherit;
    align-items: center;
  }

  .van-card__desc {
    max-height: 14vw;
    margin-bottom: 1vw;
    width: 38.5vw;
    line-height: inherit;
    font-size: 11px;
  }
  .van-ellipsis {
    white-space: normal;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .van-card__bottom {
    margin-top: 9vw;
  }
  .checkboxGroup {
    background-color: #fff;
    border-bottom: 1px solid #f8f8f8;
    padding: 2vw 0;
  }

  .van-card {
    background-color: #fff;
    padding: 2.13333vw 2vw;
  }
  .van-card__title {
    margin-bottom: 1vw;
    width: 38vw;
    padding-top: 0;
  }
}
</style>